// extracted by css-extract-rspack-plugin
export default {"EditingParameterContainer":"AejB5","isEditingParameter":"YdNUe"};